import React, { useEffect, useRef, useState } from "react";

import { Input, Button, Image, Table, Select, Modal, DatePicker, message, Checkbox, QRCode, TimePicker } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { API_BASE_URL } from "../services/apiConfig";
import {API_BASE_URL_ISSUER} from "../services/apiConfig";
import AuthService from "../services/auth.service";
interface ClubInfo {
  club_seq: number;
  club_name: string;
  valid: boolean;
  club_category_seq: number;
  agentSeq: number;

}

interface NotificationView {
  selectedClubInfo: ClubInfo | null;
  selectmemberidsoket: any;
  onselectedDeviceNameChange: (selectedDeviceName: any) => void;
  onselectchangeupdate: (selectchangeroom: any) => void;
  profiledata: any;
}
const NotificationView: React.FC<NotificationView> = ({ selectedClubInfo, selectmemberidsoket, onselectedDeviceNameChange, profiledata, onselectchangeupdate }) => {
  const [notificationcount, setnotificationcount] = useState<any>(0);
  const [noticesselectedRow, setnoticesselectedRow] = useState<number | null>(
    null
  );
  const [noticesselectetitle, setnoticesselecteTitle] = useState("");
  const [noticesselectecontent, setnoticesselecteContent] = useState("");
  const [noticesselecteindex, setnoticesselecteindex] = useState("");
  const [noticesselecteseq, setnoticesselecteseq] = useState("");

  const [width, setWidth] = useState(window.innerWidth);
  const [imageSrc, setImageSrc]: any = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [notices, setNotices] = useState<any[]>([]);
  const [token, settoken] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { TextArea } = Input;
  useEffect(() => {
    const rawToken = AuthService.getRawToken();
    settoken(rawToken);
  }, []);
  useEffect(() => {
    if (token !== null) {
      fetchnotificationDataAPI();
    }
  }, [token]);


  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const onUpload = (e: any) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        setImageSrc(reader.result);
      };

      reader.readAsDataURL(file);
    }
  };


  const NotificationsaveClick = () => {



    if (noticesselecteindex === "new") {
      console.log("(ExcelUpload) 새등록모드");
      const titleInput = document.getElementById(
        "titleInput"
      ) as HTMLInputElement;
      const contentInput = document.getElementById(
        "contentInput"
      ) as HTMLInputElement;

      const title = titleInput.value;
      const content = contentInput.value;
      const noticeselectedImage = fileInputRef.current?.files?.[0];

      const formData = new FormData();

      const memberData = {
        clubSeq: selectedClubInfo?.club_seq,
        noticeTitle: title + "",
        noticeMessage: content + "",
        noticeUrl: "url",
        fileExists: true,
      };
      // console.log("#새소식 등록 정보" + JSON.stringify(memberData, null, 2));
      const jsonBlob = new Blob([JSON.stringify(memberData)], {
        type: "application/json",
      });

      formData.append("clubNoticeWithCommentDto", jsonBlob);

      // console.log("이미지여부  :" + noticeselectedImage);
      if (noticeselectedImage === undefined) {
        // console.log("이미지없음 ")
        const emptyBlob = new Blob([], { type: "image/png" });
        const emptyImageFile = new File([emptyBlob], "empty_image.png", {
          type: "image/png",
        });
        formData.append("imagePath", emptyImageFile, "image.png");

      } else {
        // console.log("이미지있음 ")
        formData.append("imagePath", noticeselectedImage, "image.png");

      }

      // console.log("토큰@@@@ :" + token + "//");
      console.log(`${API_BASE_URL}/club/notice/withfile/create`)
      fetch(`${API_BASE_URL}/club/notice/withfile/create`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          // console.log("(ExcelUpload) POST 요청 성공:", data);
          const newNotice = {
            title: title,
            content: content,
          };

          setNotices([...notices, newNotice]);

          setnoticesselectedRow(null);
          setnoticesselecteTitle("");
          setnoticesselecteContent("");
          setnoticesselecteindex("");
          setnoticesselecteseq("");
          setImageSrc("");
          setImageUrl("");
          fetchnotificationDataAPI();

          window.alert("새소식사항 등록되었습니다.");
        })
        .catch((error) => {
          console.error("(ExcelUpload) Error:", error);
        });
    } else {
      // console.log(
      //   "(ExcelUpload) 수정모드" +
      //   noticesselecteindex +
      //   "/클럽새소식시퀀스" +
      //   noticesselecteseq
      // );

      const titleInput = document.getElementById(
        "titleInput"
      ) as HTMLInputElement;
      const contentInput = document.getElementById(
        "contentInput"
      ) as HTMLInputElement;

      const title = titleInput.value;
      const content = contentInput.value;
      const noticeselectedImage = fileInputRef.current?.files?.[0];

      const formData = new FormData();

      const memberData = {
        clubSeq: selectedClubInfo?.club_seq,
        clubNoticeSeq: noticesselecteseq,
        noticeTitle: title + "",
        noticeMessage: content + "",
        noticeUrl: "url",
        fileExists: true,
      };

      // console.log(memberData);
      const jsonBlob = new Blob([JSON.stringify(memberData)], {
        type: "application/json",
      });

      formData.append("clubNoticeWithCommentDto", jsonBlob);

      if (noticeselectedImage) {
        const emptyBlob = new Blob([], { type: "image/png" });
        const emptyImageFile = new File([emptyBlob], "empty_image.png", {
          type: "image/png",
        });

        formData.append("imagePath", noticeselectedImage, "image.png");
        // console.log("사진있음")
      } else {
        // console.log("사진없음")
      }
      console.log(`${API_BASE_URL}/club/notice/withfile/update`);
      fetch(`${API_BASE_URL}/club/notice/withfile/update`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          // console.log("(ExcelUpload) POST 요청 성공:", data);
          const newNotice = {
            title: title,
            content: content,
          };

          setNotices([...notices, newNotice]);

          setnoticesselectedRow(null);
          setnoticesselecteTitle("");
          setnoticesselecteContent("");
          setnoticesselecteindex("");
          setnoticesselecteseq("");
          fetchnotificationDataAPI();
          window.alert("새소식사항 수정되었습니다.");
        })
        .catch((error) => {
          console.error("(ExcelUpload) Error:", error);
        });
    }
    fetchnotificationDataAPI();
  };
  const NotificationinsertClick = () => {
    // 새소식등록
    if (noticesselectedRow === 1) {
      setnoticesselectedRow(null);
      setnoticesselecteTitle("");
      setnoticesselecteContent("");
      setnoticesselecteindex("");
      setnoticesselecteseq("");
      setImageUrl("");
      setImageSrc("");
    } else {
      setnoticesselectedRow(1);
      setnoticesselecteTitle("");
      setnoticesselecteContent("");
      setnoticesselecteindex("");
      setnoticesselecteseq("");
      setImageUrl("");
      setImageSrc("");
    }

    setnoticesselecteindex("new");
  };

  const fetchnotificationDataAPI = async () => {
    if (token !== null && selectedClubInfo?.club_seq !== undefined) {
      // 새소식사항
      fetch(
        `${API_BASE_URL}/club/notice/withfile/list/${selectedClubInfo?.club_seq}?page=0&size=200000&sort=clubNoticeSeq,desc`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then(
          (data: {
            data: {
              content: Array<{
                clubSeq: number;
                clubNoticeSeq: number;
                noticeTitle: string;
                noticeMessage: string;
                created: string;
                valid: boolean;
                imagePath: string;
              }>;
            };
          }) => {
            const validNotices = data.data.content.filter(
              (item) => item.valid === false
            );
            // console.log("(ExcelUpload) 새소식API Response:", data.data.content);

            const notices = validNotices.map((item) => ({
              clubNoticeSeq: item.clubNoticeSeq,
              clubSeq: item.clubNoticeSeq,
              title: item.noticeTitle,
              content: item.noticeMessage,
              created: item.created,
              imagePath: item.imagePath,
            }));

            setNotices(notices);
            setnotificationcount(notices.length);
          }
        )
        .catch((error) => {
          console.error("(ExcelUpload) Error:", error);
        });
    }
  };
  const handleRowClick = (index: number) => {
    if (noticesselectedRow === index) {
      setnoticesselectedRow(null);
      setnoticesselecteTitle("");
      setnoticesselecteContent("");
      setnoticesselecteindex("");
      setnoticesselecteseq("");
      setImageUrl("");
      setImageSrc("");
    } else {
      setnoticesselectedRow(index);
      const clickedNotice = notices[index];
      setnoticesselecteTitle(clickedNotice.title);
      setnoticesselecteContent(clickedNotice.content);
      setnoticesselecteindex(index + "");
      setnoticesselecteseq(clickedNotice.clubNoticeSeq);

      setImageUrl(clickedNotice.imagePath);
      // console.log("이미지 " + clickedNotice.imagePath);
    }
  };
  const formatDate = (dateString: any) => {
    const date = new Date(dateString);
    return `${date.getFullYear()}.${date.getMonth() + 1}.${date.getDate()}`;
  };
  return (

    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", padding:"20px" }}>
      <div style={{ fontSize: "24px" }}>| { } 새소식</div>

      <div
        style={{
          display: "flex",
          width: "100%",
          height: "1000px",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            width: "100%",
            height: width <= 1600 ? "400px" : "1000px",
            overflowY: "auto",
            borderRight: "1px solid #ccc", // 세로선 스타일
          }}
        >
          <div
            style={{
              margin: "30px",
              height: width <= 1600 ? "400px" : "800px",
            }}
          >
            <table
              style={{ borderCollapse: "collapse", width: "100%" }}
            >
              <thead>
                <tr style={{ backgroundColor: "#f2f2f2" }}>
                  <th
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "center",
                      padding: "8px",
                      width: "5%",
                    }}
                  >
                    No.
                  </th>
                  <th
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "center",
                      padding: "8px",
                      width: "60%",
                    }}
                  >
                    제목
                  </th>
                  <th
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "center",
                      padding: "8px",
                      width: "35%",
                    }}
                  >
                    등록일
                  </th>
                </tr>
              </thead>
              <tbody style={{ maxHeight: "400px", overflowY: "auto" }}>
                {notices.length > 0 ? (
                  notices.map((notice, index) => (
                    <tr
                      key={index}
                      onClick={() => handleRowClick(index)}
                      style={{
                        cursor: "pointer",
                        borderBottom: "1px solid #dddddd",
                      }}
                    >
                      <td
                        style={{
                          border: "1px solid #dddddd",
                          padding: "8px",
                        }}
                      >
                        {index + 1}
                      </td>
                      <td
                        style={{
                          border: "1px solid #dddddd",
                          padding: "8px",
                        }}
                      >
                        {notice.title}
                      </td>
                      <td
                        style={{
                          border: "1px solid #dddddd",
                          padding: "8px",
                        }}
                      >
                        {formatDate(notice.created)}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      style={{
                        border: "1px solid #dddddd",
                        padding: "8px",
                      }}
                    ></td>
                    <td
                      style={{
                        border: "1px solid #dddddd",
                        padding: "8px",
                      }}
                    >
                      새소식이 없습니다.
                    </td>
                    <td
                      style={{
                        border: "1px solid #dddddd",
                        padding: "8px",
                      }}
                    ></td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div style={{ width: "100%", height: "100px" }}>
            <button
              style={{
                cursor: "pointer",
                width: "320px",
                height: "70px",
                margin: "15px",
                borderRadius: "10px",
                backgroundColor: "#2D5478",
                border: "1px solid #2D5478", // Set border color and thickness
                color: "white",
              }}
              onClick={NotificationinsertClick}
            >
              새소식 작성하기
            </button>
          </div>
        </div>

        <div
          style={{
            width: "32.81%",
            height: "1000px",
            borderLeft: "1px solid #ccc", // 세로선 스타일
            display: noticesselectedRow !== null ? "block" : "none",
          }}
        >
          <h2 style={{ textAlign: "left", margin: "50px" }}>새소식 작성</h2>
          <div style={{ textAlign: "left", margin: "50px" }}>
            제목
            <div style={{ marginTop: "20px" }}>
              <Input
                id="titleInput"
                value={noticesselectetitle}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setnoticesselecteTitle(e.target.value)
                } // 값이 변경될 때마다 호출됨
                placeholder="제목을 입력해주세요."
                style={{
                  width: width <= 1600 ? "300px" : "400px",
                  // borderBottom: "1px solid black",
                  // border: "none",
                  borderRadius: "5px",
                  // outline: "none",
                  marginRight: "10px", // 오른쪽 여백 추가
                }}
              />
              <Image
                src="asset/img/Line.png"
                preview={false}
                style={{
                  width: "400px",
                  height: "2px",
                  marginTop: "-20px",
                  marginLeft: "-5px",
                }}
              />
            </div>
          </div>

          <div style={{ textAlign: "left", margin: "50px" }}>
            내용
            <div style={{ marginTop: "20px", textAlign: "left" }}>
              <TextArea
                id="contentInput"
                placeholder="내용을 입력해주세요."
                value={noticesselectecontent}
                autoSize={{ minRows: 20, maxRows: 80 }}
                onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                  setnoticesselecteContent(e.target.value)
                }
                style={{
                  width: "400px",
                  height: "500px",
                  marginRight: "10px", // 오른쪽 여백 추가
                  paddingTop: "10px", // 위쪽 패딩 추가
                  verticalAlign: "top", // 텍스트를 위로 정렬
                  lineHeight: "1.0", // 줄 간격 설정
                }}
                defaultValue="" // 초기값 설정
              />
            </div>
          </div>
          <div
            style={{
              width: "100%",
              height: "100px",
              textAlign: "left",
              marginLeft: "50px",

            }}
          >
            <div style={{}}>

              <input
                type="file"
                ref={fileInputRef}
                onChange={onUpload}
              />
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  // backgroundColor:"black"
                }}
              >
                <img
                  src={imageUrl}
                  style={{ maxWidth: "100%", maxHeight: "200px" }}
                />

                {imageSrc && (
                  <img
                    width={"200px"}
                    src={imageSrc}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "200px",
                      marginTop: "10px",
                    }}
                  />
                )}
              </div>
            </div>
            {/* 
          <button
            style={{
              cursor: notificationcount === 0 ? "" : "pointer",
              width: "150px",
              height: "56px",
              borderRadius: "10px",
              backgroundColor: "#ffff",
              border: "1px solid #2D5478", // Set border color and thickness
              color: "#000",
            }}
            onClick={NotificationDeleteClick}
            disabled={notificationcount === 0}
          >
            지우기
          </button> */}
            <button
              style={{
                cursor: "pointer",
                width: "240px",
                height: "55px",
                margin: "15px",
                borderRadius: "10px",
                backgroundColor: "#2D5478",
                border: "1px solid #2D5478", // Set border color and thickness
                color: "white",
              }}
              onClick={NotificationsaveClick}
            >
              저장
            </button>
          </div>
        </div>
      </div>




    </div>

  );

};

export default NotificationView;
